export default __webpack_public_path__ + "static/media/toNiacinamide.a11b8d8a.webp";